import React from 'react'
import Svg, {Path} from 'react-native-svg'

import {type Props, useCommonSVGProps} from '#/components/icons/common'

export const Lightning_Stroke2_Corner0_Rounded = React.forwardRef<
  Svg,
  Props
>(function LightningStroke(props, ref) {
  const {fill, size, style, ...rest} = useCommonSVGProps(props)

  return (
    <Svg
      fill="none"
      {...rest}
      ref={ref}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      style={[style]}>
      <Path
        d="M14.5 1L3 13.5h8.5l-.5 9.5 11.5-12.5h-8.5L14.5 1Z"
        fill="none"
        stroke={fill}
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
    </Svg>
  )
})

export const Lightning_Filled_Corner0_Rounded = React.forwardRef<
  Svg,
  Props
>(function LightningFilled(props, ref) {
  const {fill, size, style, ...rest} = useCommonSVGProps(props)

  return (
    <Svg
      fill="none"
      {...rest}
      ref={ref}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      style={[style]}>
      <Path
        d="M14.5 1L3 13.5h8.5l-.5 9.5 11.5-12.5h-8.5L14.5 1Z"
        fill={fill}
        stroke={fill}
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
    </Svg>
  )
})
